export const SET_SUPPLIERS = 'SET_CATEGORIES';
export const SET_SUPPLIERS_DATA_LOADING = 'SET_CATEGORY_DATA_LOADING';
export const SET_SEARCH_SUPPLIER_BY_ID = 'SET_SEARCH_SUPPLIER_BY_ID'; 